import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from  'vue-meta'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
/*  {
    path: '/collection',
    name: 'collection',
    // route level code-splitting
    // this generates a separate chunk (collection.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Collection.vue'),
  },*/
  {
    path: '/collection/SS2023',
    name: 'SS2023',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/facemask',
    name: 'facemask',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/accessories',
    name: 'accessories',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/FW2023',
    name: 'FW2023',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/swimwear',
    name: 'swimwear',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/SS2024',
    name: 'SS2024',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/FW2024',
    name: 'FW2024',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/FW2025',
    name: 'FW2025',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/FW2026',
    name: 'FW2026',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/home-wellness',
    name: 'home-wellness',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/goodies',
    name: 'goodies',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/SS2025',
    name: 'SS2025',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/collection/katemack-for-male',
    name: 'katemack-for-mail',
    component: () => import('../views/Collection.vue'),
  },
  {
    path: '/group-collection/winter-style',
    name: 'winter-style',
    component: () => import('../views/Group.vue'),
  },
  {
    path: '/group-collection/summer-style',
    name: 'summer-style',
    component: () => import('../views/Group.vue'),
  },
  {
    path: '/group-collection/resort',
    name: 'resort',
    component: () => import('../views/Group.vue'),
  },
  {
    path: '/press',
    name: 'press',
    component: () => import('../views/Press.vue')
  },
  {
    path: '/bio',
    name: 'bio',
    component: () => import('../views/Bio.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '*',
    component: Home
  }
]


const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
